export default "__VITE_ASSET__2tDY$xZl__"